import { MYNAVI_PRIMARY } from '@/components/Campaign/mynavi/Color'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { MyNaviWishButton } from '@/components/Campaign/mynavi/MyNaviWishButton/MyNaviWishButton'
import type { MynaviOpenCampusItem } from '@/schemas/v2/mynavi'

export type MyNaviOpenCampusItemProps = {
  oc: MynaviOpenCampusItem
  isWished: boolean
  onToggleWanted: () => void
  /** undefined の場合はボタンを disabled にする */
  onViewDetail?: () => void
}

export const formatEventDate = (eventDate: string | null): { year: string; monthDay: string } => {
  if (!eventDate) return { year: '', monthDay: '' }
  const [y, m, d] = eventDate.split('-').map(Number)
  const date = new Date(y, m - 1, d)
  const year = `${date.getFullYear()}年`
  const weekDays = ['日', '月', '火', '水', '木', '金', '土']
  const monthDay = `${date.getMonth() + 1}/${date.getDate()}(${weekDays[date.getDay()]})`
  return { year, monthDay }
}

export const MyNaviOpenCampusItem = ({ oc, isWished, onToggleWanted, onViewDetail }: MyNaviOpenCampusItemProps) => {
  const { year, monthDay } = formatEventDate(oc.eventDate)

  return (
    <div className="py-2">
      {/* 開催日枠 */}
      <div
        className="border border-[#686868] rounded-[5px] mx-4 px-3 pt-4 pb-[21px] bg-[#fbfbfb]"
        style={{ minHeight: '92px' }}
      >
        {/* 年 */}
        {year && (
          <MyNaviTypography variant="micro" className="leading-none mb-1">
            {year}
          </MyNaviTypography>
        )}

        {/* 月日 / 行きたいボタン */}
        <div className="flex items-center justify-between gap-3">
          <MyNaviTypography variant="caption" className="leading-none">
            {monthDay}
          </MyNaviTypography>
          <MyNaviWishButton isWished={isWished} onClick={onToggleWanted} />
        </div>

        {/* キャンパス名 / ポイント */}
        <div className="flex items-center mt-2">
          <MyNaviTypography variant="caption" className="flex-1 min-w-0 leading-none">
            {oc.location}
          </MyNaviTypography>
          {/* 行きたいボタン（83px）の真下に右詰めで配置 */}
          <div className="flex w-[83px] shrink-0 justify-end">
            {oc.point != null && (
              <MyNaviTypography
                variant="caption"
                className="leading-none"
                style={{ color: MYNAVI_PRIMARY, fontWeight: 700, textAlign: 'right' }}
              >
                {oc.point.toLocaleString('ja-JP')}pt
              </MyNaviTypography>
            )}
          </div>
        </div>

        {/* イベント名 */}
        {oc.eventName && (
          <MyNaviTypography variant="caption" as="p" className="mt-2 leading-none">
            {oc.eventName}
          </MyNaviTypography>
        )}

        {/* 開催情報（時間の位置に表示） */}
        {oc.holdingInfo && (
          <MyNaviTypography variant="caption" as="p" className="mt-2 leading-none">
            {oc.holdingInfo}
          </MyNaviTypography>
        )}
      </div>

      {/* 詳細を見る・予約するボタン */}
      {onViewDetail && (
        <div className="px-4 mt-[13px]">
          <button
            type="button"
            onClick={onViewDetail}
            disabled={!onViewDetail}
            className="w-full h-[33px] rounded-[5px] bg-[#058bbe] text-white text-[12px] disabled:opacity-40"
            style={{ fontFamily: "'BIZ UDPGothic', sans-serif", fontWeight: 700 }}
          >
            詳細を見る・予約する
          </button>
        </div>
      )}
    </div>
  )
}
